/**
 * In de buurt component met Google Maps Places.
 */

import React, { Component } from "react";
import { connect } from "react-redux";
import setSearchUrl from "../actions/setSearchUrl";
import { queryParams } from "../store/queryParams";

import { setLocationValue, showFacetFilters } from "../reducers";
import toggleOverlay from "../actions/toggleOverlay";

class Maps extends Component {
	constructor(props) {
		super(props);

		this.state = {
			location: [],
		};
		this.autocomplete = null;
	}

	componentDidMount() {
		/**
		 * Event listener die gekoppeld wordt aan het input veld om Google Maps aan te roepen.
		 */
		this.autocomplete = new window.google.maps.places.Autocomplete(
			document.querySelector(".locationValue"),
			{
				types: ["(regions)"],
				componentRestrictions: { country: "be" },
			}
		);
		this.autocomplete.addListener("place_changed", this.handlePlaceSelect);
	}

	handlePlaceSelect = (e) => {
		let place = [];
		place = this.autocomplete.getPlace();

		if ('undefined' === typeof place.geometry) {
			return;
		}

		let lat = place.geometry.location.lat();
		let lng = place.geometry.location.lng();
		
		/**
		 * Alle values opslaan in een Maps component state, anders kan wordt er meteen een event gedispatcht.
		 */
		this.setState({
			location: {
				city: place.address_components[0].long_name,
				lat: lat,
				lng: lng,
			},
		});
	};

	render(props) {
		const { activeLocation } = this.props.state;

		const handleLocation = (e) => {
			this.props.dispatch(
				setSearchUrl({
					[queryParams.vicinityCity]: this.state.location.city,
					[queryParams.vicinityCoords]:
						this.state.location.lat + "," + this.state.location.lng,
					[queryParams.page]: "",
				})
			);
			this.props.dispatch(showFacetFilters(false));
			toggleOverlay(false);
		};

		const clearLocationClick = (e) => {
			//todo
			this.setState({
				location: [],
			});
			this.props.dispatch(
				setSearchUrl({
					[queryParams.vicinityCity]: "",
					[queryParams.vicinityCoords]: "",
					[queryParams.page]: "",
				})
			);

			/**
			 * In Vanilla clearen van input veld want met Google Maps
			 * is het niet zo meteen mogelijk om dit via een state te doen.
			 */
			document.querySelector(".locationValue").value = "";
		};

		return (
			<div className="facet__form has-xxs-top-margin">
				<div
					className="form_item"
					id="search_in_de_buurt"
					data-gtm-id="facetfilter_indebuurt"
				>
					<div className="form-row form-row--end">
						<div className="form-item">
							<label
								className="form-label"
								htmlFor="facet-vicinity"
							>
								In de buurt van
							</label>
							{/* <input type="hidden" name="indebuurt_geo" value="#" /> */}
							{!!activeLocation.city ? (
								<input
									id="facet-vicinity"
									className="form-text form-text--clearable locationValue"
									type="text"
									placeholder="Postcode of gemeente"
								/>
							) : (
								<input
									id="facet-vicinity"
									className="form-text locationValue"
									type="text"
									placeholder="Postcode of gemeente"
								/>
							)}
							{!!activeLocation.city && (
								<button
									className="form-text-clear"
									onClick={clearLocationClick}
								>
									<span className="visually-hidden">
										Zoekveld leegmaken
									</span>
									<span className="icon icon--x icon-size--l"></span>
								</button>
							)}
						</div>
						<div className="form-item form-item--static">
							<button
								className="form-button button is-style-primary"
								onClick={(e) => {
									handleLocation(e);
								}}
							>
								<span className="icon icon--magnifier icon-size--s"></span>
								<span className="visually-hidden">Zoeken</span>
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

function mapStateToProps(state) {
	return { state };
}

export default connect(mapStateToProps)(Maps);
